import React from "react";
import Image from "gatsby-image";
import { ArticlePhotos } from "./ArticlePhotos";

export const ArticleData = () => {
  const images = ArticlePhotos();
  return {
    date: "28.10.2019",
    category: "strona WWW, marketing internetowy",
    title: "E-mail marketing - czym jest i jakie niesie ze sobą korzyści?",
    description:
      "Czy wyobrażamy sobie życie bez maili? Choć żyjemy w czasach, kiedy dominuje komunikacja internetowa, to może się wydawać, że stara, dobra poczta elektroniczna odchodzi do lamusa i jest zastępowana przez komunikatory, przez które dużo łatwiej i szybciej nam się porozumiewać. Nie jest to jednak prawda. E-mail marketing bywa niedoceniany, lecz często jego wykorzystanie okazuje się strzałem w dziesiątkę.",
    seo: "Czy wyobrażamy sobie życie bez maili?",
    slug: "/blog/e_mail_marketing_czym_jest_i_jakie_niesie_ze_soba_korzysci",
    hero: (
      <Image
        alt=""
        objectPosition={"center"}
        objectFit={"contain"}
        fluid={images.hero.childImageSharp.fluid}
      />
    ),
    text: {
      first: {
        title: "E-mail marketing to działanie w gronie zainteresowanych ",
        text: (
          <>
            Skrzynkę pocztową ma właściwie każdy użytkownik internetu, a dostęp
            do niej praktycznie wszędzie i przez cały czas - w smartfonie. To
            sprawia, że poprzez e-mail marketing możemy bardzo szybko dotrzeć do
            naprawdę dużej ilości osób w wygodny dla nich sposób. Co warto
            zaznaczyć - <b>docieramy do zainteresowanych osób</b>. Wszak do
            subskrypcji zapisują się użytkownicy, którzy są zainteresowani naszą
            ofertą, co czyni ich bardziej skłonnych do, na przykład, zakupu w
            naszym sklepie. To jest również dobry sposób na
            <b> tworzenie i podtrzymywanie kontaktu z klientem</b>.
          </>
        ),
      },
      second: {
        title: "",
        text: (
          <>
            Dobrowolna subskrypcja sprawia również, że prowadzone przez nas
            działania nie są anonimowe. Zazwyczaj znamy imię (czasem też
            nazwisko), czasem nazwę firmy, a niekiedy także i inne informacje na
            temat zainteresowanego. Takie dane, jak i te gromadzone przez nas w
            ramach naszej działalności - częstotliwość odwiedzin naszej witryny
            czy konkretne preferencje zakupowe klienta - pozwalają na
            <b> łatwe targetowanie wiadomości</b>ze względu na to, na jakie
            grupy dzielą się nasi subskrybenci.
          </>
        ),
      },
      third: {
        title: "Dopasowanie wiadomości przepisem na sukces  ",
        text: (
          <>
            Skoro możemy spersonalizować wiadomości, łatwe dla nas również jest
            dopasowanie wiadomości do profilu klienta. Dzięki temu e-mail
            marketing może poszczycić się bardzo wysokim odsetkiem użytkowników,
            którzy podjęli pożądaną przez nas akcję, np. kupili produkt. Ten
            sposób promocji jest również <b>bardzo efektywny</b> - cechuje go
            najlepszy wskaźnik ilości zarobionych pieniędzy w stosunku do
            zainwestowanych.
          </>
        ),
      },
      fourth: {
        title: "E-mail marketing - wymierzony sukces  ",
        text: (
          <>
            Poza korzyściami wynikającymi z personalizowanego dostępu do
            zainteresowanych osób, e-mail marketing niesie ze sobą też korzyści
            natury technicznej. Po pierwsze, jest <b>skalowalny</b> - możemy
            dynamicznie dostosować wielkość wykupionego planu do ilości
            subskrybentów, dzięki czemu nigdy nie przepłacamy. Po drugie, efekty
            działania subskrypcji są bardzo <b>łatwo mierzalne</b> - m.in.
            możemy sprawdzić, ile osób w ogóle otrzymało i otworzyło naszego
            maila i podzielić je, na przykład, według lokalizacji.
          </>
        ),
      },
      fifth: {
        title: "",
        text: (
          <>
            E-mail marketing to potężne narzędzie, które służy zarówno małym,
            jak i dużym firmom. Odpowiednio formułowane i targetowane wiadomości
            bardzo dobrze <b>wspomagają</b> wszystkie podejmowane działania
            marketingowe. Od nas tylko zależy, jak je wykorzystamy.{" "}
          </>
        ),
      },
    },
  };
};
